import { TermViewer } from '@/components/organisms/TermViewer';
import { SEOHead } from '@/components/atoms/SEOHead';

/**
 * 투자 위험 고지 — sisegonggan.terms 테이블의 type='disclaimer' 최신 활성 버전.
 * 어드민 → 약관 관리에서 등록/수정.
 */
export function DisclaimerPage() {
  return (
    <>
      <SEOHead
        title="투자 위험 고지"
        description="시세공간 투자 위험 고지 안내"
        canonical="/disclaimer"
      />
      <TermViewer type="disclaimer" fallbackTitle="투자 위험 고지" />
    </>
  );
}
